import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import {
  ADD_SCHOR_HORIZONTAL,
  EDIT_SCHOR_HORIZONTAL,
  VIEW_SCHOR_HORIZONTAL,
  LIST_SCHOR_HORIZONTAL,
  DELETE_SCHOR_HORIZONTAL,
  ADD_SCHOR_HORIZONTAL_TEXT,
  EDIT_SCHOR_HORIZONTAL_TEXT,
  VIEW_SCHOR_HORIZONTAL_TEXT,
  LIST_SCHOR_HORIZONTAL_TEXT,
  DELETE_SCHOR_HORIZONTAL_TEXT
} from "./actionTypes"
import { schorHorizontalSuccess, schorHorizontalError } from "./actions"


import {
  onAddSchorHorizontal,
  onEditSchorHorizontal,
  onViewSchorHorizontal,
  onListSchorHorizontal,
  onDeleteSchorHorizontal,
  onAddSchorHorizontalText,
  onEditSchorHorizontalText,
  onListSchorHorizontalText,
  onViewSchorHorizontalText,
  onDeleteSchorHorizontalText
} from "helpers/backend_api_helper";

// add aspiration question
function* addSchorHorizontal({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddSchorHorizontal, data);
    yield put(schorHorizontalSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(schorHorizontalError(error?.response?.data?.message || "Server Error"));
  }
}

// edit aspiration question
function* editSchorHorizontal({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditSchorHorizontal, data, id);
    yield put(schorHorizontalSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(schorHorizontalError(error?.response?.data?.message || "Server Error"));
  }
}

// list aspiration question
function* listSchorHorizontal({ payload: { data, callback } }) {
  try {
    const response = yield call(onListSchorHorizontal, data);
    yield put(schorHorizontalSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(schorHorizontalError(error?.response?.data?.message || "Server Error"));
  }
}

// view aspiration question
function* viewSchorHorizontal({ payload: { data, history } }) {
  try {
    const response = yield call(onViewSchorHorizontal, data);
    yield put(schorHorizontalSuccess(response));

  } catch (error) {
    yield put(schorHorizontalError(error?.response?.data?.message || "Server Error"));
  }
}

// delete aspiration question
function* deleteSchorHorizontal({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteSchorHorizontal, data);
    yield put(schorHorizontalSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(schorHorizontalError(error?.response?.data?.message || "Server Error"));
  }
}


// text
// add aspiration question
function* addAspirationText({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddSchorHorizontalText, data);
    yield put(schorHorizontalSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(schorHorizontalError(error?.response?.data?.message || "Server Error"));
  }
}

// edit aspiration question
function* editAspirationText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditSchorHorizontalText, data, id);
    yield put(schorHorizontalSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(schorHorizontalError(error?.response?.data?.message || "Server Error"));
  }
}

// list aspiration question
function* listAspirationText({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onListSchorHorizontalText, data, id);
    yield put(schorHorizontalSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(schorHorizontalError(error?.response?.data?.message || "Server Error"));
  }
}

// view aspiration question
function* viewAspirationText({ payload: { data, history } }) {
  try {
    const response = yield call(onViewSchorHorizontalText, data);
    yield put(schorHorizontalSuccess(response));

  } catch (error) {
    yield put(schorHorizontalError(error?.response?.data?.message || "Server Error"));
  }
}

// delete aspiration question
function* deleteAspirationText({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteSchorHorizontalText, data);
    yield put(schorHorizontalSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(schorHorizontalError(error?.response?.data?.message || "Server Error"));
  }
}



function* SchorHorizontalSaga() {
  yield takeEvery(ADD_SCHOR_HORIZONTAL, addSchorHorizontal);
  yield takeEvery(EDIT_SCHOR_HORIZONTAL, editSchorHorizontal);
  yield takeEvery(LIST_SCHOR_HORIZONTAL, listSchorHorizontal);
  yield takeEvery(VIEW_SCHOR_HORIZONTAL, viewSchorHorizontal);
  yield takeEvery(DELETE_SCHOR_HORIZONTAL, deleteSchorHorizontal);

  // text
  yield takeEvery(ADD_SCHOR_HORIZONTAL_TEXT, addAspirationText);
  yield takeEvery(EDIT_SCHOR_HORIZONTAL_TEXT, editAspirationText);
  yield takeEvery(LIST_SCHOR_HORIZONTAL_TEXT, listAspirationText);
  yield takeEvery(VIEW_SCHOR_HORIZONTAL_TEXT, viewAspirationText);
  yield takeEvery(DELETE_SCHOR_HORIZONTAL_TEXT, deleteAspirationText);
}

export default SchorHorizontalSaga;

